import {uiMsg} from '../utils/Languages';
import React, {Component} from 'react';
import {observer} from 'mobx-react';
import AppModel from '../DataModel/AppModel';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import Chip from 'material-ui/Chip';
import Card from 'material-ui/Card/Card';
import Webcam from 'react-webcam';
import jsQR from 'jsqr';
import png from 'upng-js';
import  Subheader  from 'material-ui/Subheader';
import AppModelUtils from '../DataModel/AppModelUtils';
import {showTemporaryUIMessage} from '../utils/UIMessageBoxes.js';

const formStyle = {
  margin: 24
};

const wrapperStyle = {
  display: 'flex',
  flexWrap: 'wrap',
  margin: '10px 0px 0px 0px',
}

const chipStyle = {
  margin: '0px 5px 5px 0px'
}

export default
@observer class RegisterBeacon extends Component {

  static contextTypes = {
    router: React.PropTypes.object
  }


  state = {
    showCamera: false,
    mediaError: false
  }

  // Webcam helper functions
  setRef = webcam => {
    this.webcam = webcam;
  };

  mediaError = error => {
    this.setState({ mediaError: true, showCamera: false});
    showTemporaryUIMessage(uiMsg('BEACON_MEDIA_ERROR', "Can't open camera. Error: X", error))
  };

  capture = () => {
    var imageSrc = this.webcam.getScreenshot();
    if(imageSrc != null){
      var BASE64_MARKER = ';base64,';
      var base64Index = imageSrc.indexOf(BASE64_MARKER) + BASE64_MARKER.length;
      var base64 = imageSrc.substring(base64Index);
      var buffer = Buffer.from(base64, 'base64');
      var data = png.decode(buffer);

      const out = {
        data: new Uint8ClampedArray(png.toRGBA8(data)[0]),
        height: data.height,
        width: data.width,
      };
      var value = jsQR(out.data, out.width, out.height);
      if(value){
        console.log("Found QR code ", value.data);
        this.props.form.location["new_beacon_id"]=value.data;

        clearInterval(this.interval);
        this.setState({ showCamera: false })
        
      }
    }
  };

  openCamera(){
    this.setState({ showCamera: !this.state.showCamera });
    if (this.state.showCamera && !this.state.mediaError){
      this.interval = setInterval(this.capture, 1000); // Takes an image every second
    }else{
      clearInterval(this.interval);
    }
  }

  handleDelete(id){

    AppModelUtils.remove_beacon_from_location(id);
  }

  renderChip(data, location) {
    return (
      <Chip
        key={data}
        onRequestDelete={() => this.handleDelete(data)}
        style={chipStyle}
      >
        {data}
      </Chip>
    );
  }

  render() {
    var location = this.props.location;
    var parent = this.props.parent;
    // Video constraints
    const videoConstraints = {
      width: 1280,
      height: 720,
      facingMode: "environment"
    }
    return (
        <div>
          <div style={wrapperStyle}>

            {location.beacons.filter(Boolean).map((data) => this.renderChip(data, location))}
          </div>
            <TextField data-propname="new_beacon_id"
                      floatingLabelText={uiMsg('BEACON_BEACONID',"Beacon ID")}
                      hintText={uiMsg('BEACON_BEACONID_HINT',"12 Characters")}
                      value={location.new_beacon_id || ""}
                      onChange={parent.handleValue}
                      fullWidth={true}
            />

            <RaisedButton primary style={AppModel.betaTester ? {}:{display:'none'}}
                          onTouchTap={this.openCamera.bind(this)}
                          fullWidth={true}>
                          {this.state.showCamera ? uiMsg('BEACON_CLOSE', "Close") : uiMsg('BEACON_SCAN_BEACON', "Scan beacon")}
            </RaisedButton>
            { this.state.showCamera ? 
                <Card>
                <Webcam audio={false} width="100%" ref={this.setRef} onUserMediaError={this.mediaError} screenshotFormat="image/png" videoConstraints={videoConstraints}/>
                </Card>
            : null }
        </div>

    );
  }

};



/** WEBPACK FOOTER **
 ** ./src/components/RegisterBeacon.jsx
 **/